import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Header from "../component/Header";
import Footer from "../component/Footer";


export default function Router() {
    const [loading, setLoading] = useState(true)
    const [headerData, setHeaderData] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <BrowserRouter>
                {/* <Header setHeaderData={setHeaderData} /> */}
                <Header />
                <Routes basename={'/about'}>
                    <Route path="/about" element={<Home />} />
                    {/* <Route path="*" element={<Route404 />} /> */}
                </Routes>
                <Footer />
            </BrowserRouter >
        </>
    );
}